var map = {
	"./1F492.svg": "e28d",
	"./1F493.svg": "8714",
	"./1F494.svg": "457e",
	"./1F495.svg": "5ed5",
	"./1F496.svg": "a1f2",
	"./1F497.svg": "c4d9",
	"./1F498.svg": "b31c",
	"./1F600.svg": "acfc",
	"./1F601.svg": "1a67",
	"./1F602.svg": "7064",
	"./1F603.svg": "f699",
	"./1F604.svg": "2eb6",
	"./1F605.svg": "3e83",
	"./1F606.svg": "6d48",
	"./1F607.svg": "5d7c",
	"./1F608.svg": "83be",
	"./1F609.svg": "9c3b",
	"./1F60A.svg": "70c8",
	"./1F60B.svg": "c916",
	"./1F60C.svg": "bbc6",
	"./1F60D.svg": "0c98",
	"./1F60E.svg": "83c6",
	"./1F60F.svg": "3319",
	"./1F610.svg": "9822",
	"./1F611.svg": "1b39",
	"./1F612.svg": "cd22",
	"./1F613.svg": "9a65",
	"./1F614.svg": "9c07",
	"./1F615.svg": "a0e3",
	"./1F616.svg": "116a",
	"./1F617.svg": "a37c",
	"./1F618.svg": "7c75",
	"./1F619.svg": "8a9b",
	"./1F61A.svg": "03a2",
	"./1F61B.svg": "a696",
	"./1F61C.svg": "2f9b",
	"./1F61D.svg": "0662",
	"./1F61E.svg": "76ca",
	"./1F61F.svg": "8754",
	"./1F620.svg": "68a8",
	"./1F621.svg": "7bba",
	"./1F622.svg": "5d32",
	"./1F623.svg": "c7f2",
	"./1F624.svg": "26da",
	"./1F625.svg": "5380",
	"./1F626.svg": "bf86",
	"./1F627.svg": "c5f9",
	"./1F628.svg": "594c",
	"./1F629.svg": "24f2",
	"./1F62A.svg": "e9f0",
	"./1F62B.svg": "3dd7",
	"./1F62C.svg": "a32e",
	"./1F62D.svg": "5ab5",
	"./1F62E.svg": "3533",
	"./1F62F.svg": "e13e",
	"./1F630.svg": "34c0",
	"./1F631.svg": "5f3d",
	"./1F632.svg": "336a",
	"./1F633.svg": "6e3c",
	"./1F634.svg": "1097",
	"./1F635.svg": "df03",
	"./1F636.svg": "c58a",
	"./1F637.svg": "db25",
	"./1F638.svg": "104d",
	"./1F639.svg": "9425",
	"./1F63A.svg": "ff7d",
	"./1F63B.svg": "2839",
	"./1F63C.svg": "712a",
	"./1F63D.svg": "d1ab",
	"./1F63E.svg": "c073",
	"./1F63F.svg": "048a",
	"./1F640.svg": "f54c",
	"./1F641.svg": "18a7",
	"./1F642.svg": "fc19",
	"./1F643.svg": "2c3f",
	"./1F644.svg": "64ac",
	"./1F910.svg": "f0c1",
	"./1F911.svg": "d46d",
	"./1F912.svg": "df09",
	"./1F913.svg": "7d4e",
	"./1F914.svg": "3d7a",
	"./1F915.svg": "111d",
	"./1F917.svg": "71c2",
	"./1F920.svg": "fcf5",
	"./1F921.svg": "dd5c",
	"./1F922.svg": "3228",
	"./1F923.svg": "4268",
	"./1F924.svg": "7e9c",
	"./1F925.svg": "1768",
	"./1F927.svg": "b87a",
	"./1F929.svg": "9540",
	"./1F92A.svg": "2d84",
	"./1F92B.svg": "dbbc",
	"./1F92C.svg": "3f9c",
	"./1F92D.svg": "1147",
	"./1F92E.svg": "6c56",
	"./1F92F.svg": "a185",
	"./1F970.svg": "08f4",
	"./1F971.svg": "8bc5",
	"./1F972.svg": "906a",
	"./1F973.svg": "8409",
	"./1F974.svg": "bce4",
	"./1F975.svg": "901b",
	"./1F976.svg": "8d7d",
	"./1F978.svg": "3e63",
	"./1F97A.svg": "23e7",
	"./2639.svg": "d7a1",
	"./263A.svg": "79a3",
	"./E280.svg": "48df",
	"./E281.svg": "b587",
	"./E282.svg": "ec0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "911e";